//#region Imports
import React from "react";
import { Navigate } from "react-router";

import { useSelector } from "react-redux";

import { BASE_PATHS } from "../../../constants/pathes";
//#endregion

/**
 * Creates a private route.
 * If the user is logged in and has access to the landing page, they will be redirected to that page.
 * If the user is not logged in, they are redirected to the /login page.
 * If the user is logged in but does not have access to the target page, they are redirected to the /404 page.
 * @param {Object} props Props of the component;
 * @param {string} [props.permissionId] ID Token of the page from DB, e.g. "ai-host", "uiremote-desktop". "Public" by default;
 * @param {JSX.Element} props.children Target page to be displayed;
 * @returns {JSX.Element}
 * 
 * @example <caption>Example of the standard element usage</caption>
 * <Route path="/example-path" element={
        <ProtectedRoute permissionId="example-page">
          <ExamplePage />
        </ProtectedRoute>
      }
    />
 */
export const ProtectedRoute = ({ permissionId = "public", children }) => {
  const isLogin = useSelector((state) => state.userInfo.isLogin);
  const pages = useSelector((state) => state.userInfo.pages || []);

  if (isLogin === null) return;

  if (!isLogin) {
    return <Navigate to={BASE_PATHS.login} replace />;
  }
  if (permissionId === "public" || pages.includes(permissionId))
    return children;
  else return <Navigate to={BASE_PATHS.notExistingPage} replace />;
};
